'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-portal/lib/utils.js
// module id = 4418
// module chunks = 168707334958949